import { baseCheckboxStyles } from 'assets/styles/components/Checkbox.styles';

import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  ...baseCheckboxStyles(theme),
}));

export default useStyles;
